import { Component, Input } from '@angular/core';

@Component({
  selector: 'data-cell',
  template: `
    <div class="row">
      <div class="col-xs-12 ">
        <number-cell [numberValue]="cellValues"></number-cell>
      </div>
    </div>
  `
})
export class DataCellComponent {
  @Input() cellValues;
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/data-cell/data-cell.component.ts